import { request } from '../axios/request';

import {
  TRANSFER_OMS_COMMAND_PENDING,
  TRANSFER_OMS_COMMAND_REJECTED,
  TRANSFER_OMS_COMMAND_FULFILLED,
  CLEAR_TRANSFER_OMS_COMMAND,
} from '../constants/transferOmsCommand';

const OMS = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const pending = () => ({
  type: TRANSFER_OMS_COMMAND_PENDING,
});

const fulfilled = (response) => ({
  type: TRANSFER_OMS_COMMAND_FULFILLED,
  response,
});

const rejected = (error) => ({
  type: TRANSFER_OMS_COMMAND_REJECTED,
  error,
});

export const clearOmsCommand = () => ({
  type: CLEAR_TRANSFER_OMS_COMMAND,
});

export const omsCommand =
  (transferOrderId, selectedIds, actionParams) => (dispatch) => {
    const { id: transition, source_state, destination_state } = actionParams;
    const url = OMS.OMS.TRANSFER_ORDER_DETAIL_COMMAND.replace(
      '{0}',
      transferOrderId
    );

    const data = {
      input_parameters: {
        package_items: selectedIds,
      },
      transition,
      source_state,
      destination_state,
    };

    dispatch(pending());

    request({
      method: 'POST',
      url,
      data,
    })
      .then((response) => {
        dispatch(fulfilled(response));
      })
      .catch((error) => {
        dispatch(rejected({ apiError: error }));
      });
  };



// WEBPACK FOOTER //
// ./src/actions/transferOmsCommand.js